import React, { useState } from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Box, IconButton, Tooltip as MuiTooltip, Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { useData } from '../context/DataContext';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend, ChartDataLabels);

const TercerizacionAlmacen = ({ selectedIndustries = [], onBarClick = () => {} }) => {
  const [infoOpen, setInfoOpen] = useState(false);
  const { getWarehouseOutsourcing, dataReady } = useData();

  // Get data from Excel (3 years: 2023, 2024, 2025)
  const excelData = dataReady ? getWarehouseOutsourcing() : { labels: [], data2023: [], data2024: [], data2025: [] };

  // Use Excel data or fallback
  const allLabels = excelData.labels.length > 0
    ? excelData.labels
    : ['Sector salud/ Farmacéuticas', 'Construcción', 'Automotriz', 'Manufactura', 'Servicios logísticos', 'Alimentos', 'Retail'];

  const allData2023 = excelData.data2023.length > 0 ? excelData.data2023 : [0, 34, 54, 17, 64, 24, 31];
  const allData2024 = excelData.data2024.length > 0 ? excelData.data2024 : [11, 36, 56, 20, 41, 21, 24];
  const allData2025 = (excelData.data2025 && excelData.data2025.length > 0) ? excelData.data2025 : [24, 41, 38, 29, 41, 41, 28];

  const labels = selectedIndustries.length > 0 ? selectedIndustries : allLabels;

  const getValuesForLabels = (allValues) => labels.map((label) => {
    const index = allLabels.indexOf(label);
    return index !== -1 ? allValues[index] : 0;
  });

  const chartData = {
    labels: labels,
    datasets: [
      {
        label: '2023',
        data: getValuesForLabels(allData2023),
        backgroundColor: '#A2AEBB',
        borderColor: '#fff',
        borderWidth: 1,
      },
      {
        label: '2024',
        data: getValuesForLabels(allData2024),
        backgroundColor: '#476A8E',
        borderColor: '#fff',
        borderWidth: 1,
      },
      {
        label: '2025',
        data: getValuesForLabels(allData2025),
        backgroundColor: '#1F3D58',
        borderColor: '#fff',
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: 40,
        bottom: 40,
        left: 20,
        right: 20,
      },
    },
    plugins: {
      legend: { position: 'top' },
      tooltip: {
        callbacks: {
          label: (context) => `${context.dataset.label}: ${context.raw}%`,
        },
      },
      datalabels: {
        color: '#000',
        anchor: 'end',
        align: 'top',
        offset: (context) => {
          // Stagger labels vertically to avoid overlap
          return context.datasetIndex === 0 ? 2 : 14;
        },
        formatter: (value) => `${value}%`,
        font: { weight: 'bold', size: 9 },
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'Industria',
        },
        stacked: false,
      },
      y: {
        title: {
          display: true,
          text: 'Porcentaje (%)',
        },
        beginAtZero: true,
        max: 100,
        stacked: false,
      },
    },
    onClick: (event, elements) => {
      if (elements.length > 0) {
        const index = elements[0].index;
        const industry = chartData.labels[index];
        onBarClick([industry]);
      }
    },
  };

  const infoContent = {
    formula: 'Tercerización de almacenes (%)= (Capacidad de almacenamiento de terceros / Capacidad de almacenamiento total) × 100',
    description: 'Mide la proporción de las operaciones de almacenamiento que una empresa delega a terceros en comparación con las que maneja internamente. Se puede medir en volumen o espacio de almacenamiento (posiciones pallets, metros cuadrados, etc.).',
  };

  return (
    <div style={{ maxWidth: '800px', height: '500px', margin: '0 auto', padding: '20px' }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <MuiTooltip title="Información de la gráfica">
          <IconButton onClick={() => setInfoOpen(true)}>
            <InfoIcon />
          </IconButton>
        </MuiTooltip>
      </Box>
      <Bar data={chartData} options={options} />
      <Dialog open={infoOpen} onClose={() => setInfoOpen(false)}>
        <DialogTitle>Información de la Gráfica</DialogTitle>
        <DialogContent>
          <p><strong>Fórmula:</strong> {infoContent.formula}</p>
          <p><strong>Descripción:</strong> {infoContent.description}</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setInfoOpen(false)} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default TercerizacionAlmacen;
